import repository from "@/api/Main/userProfile";

export default {
  state: {
    profile: null,
    profile_loading: false,
  },

  getters: {
    GET_USER_PROFILE: (state) => state.profile,
    USER_PROFILE_LOADING: (state) => state.profile_loading,
    NOTIFICATIONS_SILENCED: (state, getters, rootState) => {
      const user = rootState.Login?.user;
      return !!(user && user.notifications_silenced);
    },
    NOTIFICATION_DISPLAY_MODE: (state, getters, rootState) => {
      const user = rootState.Login?.user;
      return (user && user.notification_display_mode) || "detailed";
    },
    NOTIFICATION_POPUP_TIMEOUT_MS: (state, getters, rootState) => {
      const user = rootState.Login?.user;
      const seconds = user?.notification_popup_timeout;
      if (seconds === 0) return 0;
      return (seconds ?? 6) * 1000;
    },
  },

  mutations: {
    SET_USER_PROFILE(state, data) {
      state.profile = data;
    },
    SET_USER_PROFILE_LOADING(state, val) {
      state.profile_loading = val;
    },
  },

  actions: {
    async fetchUserProfile({ commit }) {
      commit("SET_USER_PROFILE_LOADING", true);
      try {
        const res = await repository.show();
        commit("SET_USER_PROFILE", res.data);
        return res.data;
      } finally {
        commit("SET_USER_PROFILE_LOADING", false);
      }
    },

    async updateNotificationPreferences({ commit, dispatch, state, rootState }, payload) {
      const res = await repository.updateNotificationPreferences(payload);
      const user = rootState.Login?.user || {};
      commit("USERACCOUNT_LOAD", {
        ...user,
        notifications_silenced: res.data.notifications_silenced,
        notification_display_mode: res.data.notification_display_mode,
        notification_popup_timeout: res.data.notification_popup_timeout,
      });

      if (state.profile) {
        commit("SET_USER_PROFILE", {
          ...state.profile,
          notifications_silenced: res.data.notifications_silenced,
          notification_display_mode: res.data.notification_display_mode,
          notification_popup_timeout: res.data.notification_popup_timeout,
        });
      }

      if (res.data.notifications_silenced) {
        dispatch("clearPopupNotifications");
      }

      return res.data;
    },
  },
};
